export const TURNING_OFF_OFFLINE_MODE = 'turning off offline mode';
export const TURNING_ON_OFFLINE_MODE = 'turning on offline mode';

export const EVENT_STARTING_TO_STORE_CONTENT_FOR_OFFLINE_USE = 'event starting to store content for offline use';
export const EVENT_ALL_CONTENT_STORED_FOR_OFFLINE_USE = 'event all content stored for offline use';
